<template>
  <div class="search-input">
    <div
      v-if="value == '' && !isLoading"
      class="search-input__icon"
    >
      <font-awesome-icon icon="search" />
    </div>
    <div
      v-if="isLoading"
      class="search-input__loading"
    >
      <div
        v-for="x in 4"
        :key="x"
      />
    </div>
    <input
      :value="value"
      class="search-input__input"
      type="search"
      @input="handleInputValue"
    >
  </div>
</template>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'

export default {
  components: {
    FontAwesomeIcon
  },

  props: {
    value: {
      type: String,
      default: () => ''
    },
    isLoading: {
      type: Boolean,
      default: () => false
    },
  },

  methods: {
    handleInputValue (event) {
      this.$emit('input', event.target.value)
    }
  }
}
</script>

<style lang="sass">
@import '~styles/imports'
@import '~styles/forms/mixins'

.search-input
  position: relative;

.search-input__icon
  position: absolute;
  right: 0px;
  top: 6px;
  bottom: 2px;
  width: rem-calc(30)
  color: #ccc;

.search-input__loading
  position: absolute;
  background: white;
  right: 5px;
  top: 2px;
  bottom: 2px;
  width: rem-calc(40)

  div
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 22px;
    height: 22px;
    margin: 8px;
    border: 2px solid #ccc;
    border-radius: 50%;
    animation: loading 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #ccc transparent transparent transparent;

.search-input__loading div:nth-child(1)
  animation-delay: -0.45s;

.search-input__loading div:nth-child(2)
  animation-delay: -0.3s;

.search-input__loading div:nth-child(3)
  animation-delay: -0.15s;

@keyframes loading
  0%
    transform: rotate(0deg)
  100%
    transform: rotate(360deg)

.search-input__input
  @extend %form-text-input-style

  height: rem-calc(42)
  padding: rem-calc(0 18)

</style>



// WEBPACK FOOTER //
// src/components/forms/SearchInput.vue